import { client } from "./_base";

const table = "clientsconsignee";
export const clientsConsignee = client(table, (item) => ({
  ...item,
}));